import { ExpiryBehaviour, SessionExpiry } from "./SessionExpiry";

export class NullSessionExpiry implements SessionExpiry {
    set expiryBehaviour(_value: ExpiryBehaviour) {
        /* do nothing */
    }

    run(): void {
        /* do nothing */
    }
}
